import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { ChevronsLeftRight } from "lucide-react";
import { useLang } from "../i18n";

export default function BeforeAfter({ before, after, alt = "", aspect = "aspect-[4/3] sm:aspect-[16/9]" }) {
  const { t } = useLang();
  const ref = useRef(null);
  const [pos, setPos] = useState(50);
  const dragging = useRef(false);

  const update = (clientX) => {
    const rect = ref.current.getBoundingClientRect();
    const pct = ((clientX - rect.left) / rect.width) * 100;
    setPos(Math.min(96, Math.max(4, pct)));
  };

  const onDown = (e) => { dragging.current = true; update(e.clientX); };
  const onMove = (e) => { if (dragging.current) update(e.clientX); };
  const onUp = () => { dragging.current = false; };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      onPointerDown={onDown}
      onPointerMove={onMove}
      onPointerUp={onUp}
      onPointerLeave={onUp}
      className={`relative ${aspect} w-full select-none overflow-hidden border border-[#262420] bg-[#111110] cursor-ew-resize touch-pan-y`}
    >
      <img src={after} alt={alt} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt="" draggable={false} className="absolute inset-0 h-full w-full object-cover grayscale-[0.35]" />
      </div>

      <span className="pointer-events-none absolute left-4 top-4 border border-[#F3EFE6]/30 bg-[#080808]/60 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.25em] text-[#F3EFE6] backdrop-blur-md">{t.ba_before}</span>
      <span className="pointer-events-none absolute right-4 top-4 border border-[#C8A86B]/60 bg-[#080808]/60 px-3 py-1 text-[10px] font-mono uppercase tracking-[0.25em] text-[#C8A86B] backdrop-blur-md">{t.ba_after}</span>

      <div className="pointer-events-none absolute inset-y-0" style={{ left: `${pos}%` }}>
        <div className="absolute inset-y-0 -translate-x-1/2 w-[1px] bg-[#C8A86B]" />
        <motion.div
          animate={{ scale: dragging.current ? 1.1 : 1 }}
          className="absolute top-1/2 -translate-x-1/2 -translate-y-1/2 flex h-12 w-12 items-center justify-center rounded-full border border-[#C8A86B] bg-[#080808]/80 text-[#C8A86B] shadow-[0_0_40px_rgba(200,168,107,0.35)] backdrop-blur-md"
        >
          <ChevronsLeftRight size={18} />
        </motion.div>
      </div>
    </div>
  );
}
